/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './flyer-container-v2.scss'
import LoadingIndicator from 'src/components/common/LoadingIndicator'
import { changeEventForm } from 'src/actions/event'
import { connect } from 'react-redux'
import cn from 'classnames'
import { Design } from 'src/models/design.model'

const THUMB_WIDTH = 320

class FlyerContainerV2 extends Component {
  textRefs = []
  flyerText = []
  state = {
    isLoading: true,
    isInView: false,
    backGroundImageRef: null
  }

  backGroundImageElement = new Image()
  backGroundImageRef = null
  layoutImageEls = {}

  backGroundImgIntersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.setState({ isInView: true })
        observer.unobserve(entry.target)
      }
    })
  })

  design

  detectImageInViewByRef = ref => {
    if (!ref) return
    this.backGroundImgIntersectionObserver.observe(ref)
  }

  componentDidMount() {
    this.handleText()
    this.props.onRef?.(this)
  }

  componentDidUpdate() {
    for (let item of this.textRefs) {
      this.adjustSize(item)
    }
  }

  adjustSize = async element => {
    const adjustWidth = await new Promise(resolve => {
      this.adjustSizeWithWidth(element, resolve)
    })
    this.adjustSizeWithHeight(element, adjustWidth.ratio)
  }

  adjustSizeWithWidth = (element, resolve) => {
    const parentEl = element.parentNode
    const parentWidth = parentEl.offsetWidth
    const width = element.offsetWidth
    if (width > parentWidth) {
      const size = Number(getComputedStyle(parentEl)['font-size'].replace('px', ''))
      if (size <= 12) {
        const align = getComputedStyle(parentEl)['text-align']
        const ratio = 1 - (width - parentWidth) / width
        element.style.transformOrigin = 'left top'
        element.style.transform = `scale(${ratio})`

        resolve({ status: true, ratio })
        return
      } else {
        parentEl.style.fontSize = size - 1
      }
      this.adjustSizeWithWidth(element, resolve)
    } else {
      resolve({ status: true })
    }
  }

  adjustSizeWithHeight = (element, widthRatio) => {
    const parentEl = element.parentNode
    const parentHeight = parentEl.offsetHeight
    const ratio = widthRatio || 1
    const height = element.offsetHeight
    const currentHeight = height * ratio

    if (currentHeight > parentHeight) {
      const size = Number(getComputedStyle(parentEl)['font-size'].replace('px', ''))
      if (size <= 12) {
        const align = getComputedStyle(parentEl)['text-align']

        const heightRatio = ratio - (currentHeight - parentHeight) / height
        element.style.transform = `scale(${heightRatio})`
        // default
        element.style.transformOrigin = 'left top'

        if (align === 'center') {
          const currentWidth = element.offsetWidth * heightRatio
          const translateX = (parentEl.offsetWidth - currentWidth) / 2
          element.style.transform = `translateX(${translateX}px) scale(${heightRatio})`
        }

        if (align === 'right') {
          if (widthRatio) {
            const currentWidth = element.offsetWidth * heightRatio
            const translateX = parentEl.offsetWidth - currentWidth
            element.style.transform = `translateX(${translateX}px) scale(${heightRatio})`
          } else {
            element.style.transformOrigin = 'right top'
          }
        }

        return
      } else {
        parentEl.style.fontSize = size - 1
      }

      this.adjustSizeWithHeight(element)
    }
  }

  handleText = () => {
    if (!this.design?.layout) return
    this.flyerText = this.design.layout.getTexts()
  }

  renderTextEl = (item, index) => {
    const ratio = this.backGroundImageRef.clientWidth / THUMB_WIDTH
    let fontSize = item.size * ratio
    let scaleRatio = 1

    let textStyle = {
      fontFamily: item.font,
      fontSize: item.size * ratio,
      top: item.top * ratio,
      color: item.color,
      width: item.width * ratio
    }

    if (item.transformOrigin) {
      scaleRatio = fontSize / 12
      textStyle.transform = `scale(${fontSize / 12})`
      textStyle.transformOrigin = item.transformOrigin
    }

    if (item.height) {
      textStyle.height = item.height * ratio
    }

    if (item.nowrap) {
      textStyle.whiteSpace = 'nowrap'
    }

    if (item.align === 'right') {
      textStyle.right = item.right ? item.right * ratio : 0
      if (item.widthAlign === 'center') {
        textStyle.textAlign = 'center'
      } else {
        textStyle.textAlign = 'right'
      }
    } else if (item.align === 'center') {
      textStyle.left = '50%'
      textStyle.transform = `translateX(-50%) scale(${scaleRatio})`
      textStyle.textAlign = 'center'
    } else {
      if (item.widthAlign === 'center') {
        textStyle.textAlign = 'center'
      } else {
        textStyle.textAlign = 'left'
      }
      textStyle.left = item.left * ratio
    }

    if (item.verticalAlign) {
      textStyle.display = 'flex'

      if (textStyle.textAlign === 'center') {
        textStyle.justifyContent = 'center'
      } else if (textStyle.textAlign === 'right') {
        textStyle.justifyContent = 'end'
      }

      if (item.verticalAlign === 'bottom') {
        textStyle.alignItems = 'end'
      } else if (item.verticalAlign === 'center') {
        textStyle.alignItems = 'center'
      }
    }

    return (
      <div className={styles['text-box']} style={textStyle} key={index}>
        <div className={styles['text']} ref={ref => ref && this.textRefs.push(ref)}>
          {item.text}
        </div>
      </div>
    )
  }

  renderText = () => {
    this.textRefs = []
    return (
      <div className={styles['text-inner']}>
        {this.flyerText.map((item, index) => {
          if (item.type === 'date') {
            return item.dates.map((date, i) => {
              return this.renderTextEl(date, i)
            })
          }
          return this.renderTextEl(item, index)
        })}
      </div>
    )
  }

  renderOverlayImage = () => {
    const layout = this.design.layout
    const ratio = this.backGroundImageRef.clientWidth / THUMB_WIDTH

    if (!layout) return

    return layout.getFlourishes().map((item, index) => {
      const srcProp = require(`src/assets/Layouts/Flourishes/${item.name}.png`)
      let imgStyle = {
        left: item.left * ratio,
        top: item.top * ratio,
        width: item.width * ratio,
        height: item.height * ratio
      }
      return (
        <img
          style={imgStyle}
          className={styles['layout-inner']}
          key={index}
          src={srcProp}
          data-item={JSON.stringify(item)}
          crossOrigin="Anonymous"
          alt={`${item.name} can't see images? try to refresh the page.`}
          ref={(ref) => {
            if (ref) {
              this.layoutImageEls[item.name] = ref
            }
          }}
        />
      )
    })
  }

  renderBackgroundImage = () => {
    const { customBgDataURL } = this.props
    if (customBgDataURL) {
      this.backGroundImageElement.src = customBgDataURL
    } else {
      this.backGroundImageElement.src = this.getDefaultBackgroundImage()
    }

    return (
      <img
        className={this.backGroundImageElement.className}
        src={this.backGroundImageElement.src}
        ref={(ref) => {
          if (!this.state.backGroundImageRef) {
            this.backGroundImageRef = ref
            this.setState({ backGroundImageRef: ref })
          }
        }}
        alt={`${this.props.flyerDetail?.layout_slug} can't see image? try to refresh the page.`}
      />
    )
  }

  canvasToImage = () => {
    const layoutImageEls = Object.values(this.layoutImageEls)
    const flyerText = this.flyerText
    const { onChangeEventForm } = this.props
    const canvasWidth = this.backGroundImageElement.width
    const canvasHeight = this.backGroundImageElement.height
    const ratio = this.backGroundImageElement.width / THUMB_WIDTH

    const canvasEl = document.createElement('canvas')
    const context = canvasEl.getContext('2d')
    canvasEl.className = styles['canvas']
    canvasEl.width = canvasWidth
    canvasEl.height = canvasHeight

    // image
    context.drawImage(this.backGroundImageElement, 0, 0, canvasWidth, canvasHeight)
    if (layoutImageEls.length > 0) {
      for (let i = 0; i < layoutImageEls.length; i++) {
        const imageEl = layoutImageEls[i]
        const imagePosition = JSON.parse(imageEl.getAttribute('data-item'))
        const layoutWidth = imagePosition.width * ratio
        const layoutHeight = imagePosition.height * ratio
        const layoutTop = imagePosition.top * ratio
        const layoutLeft = imagePosition.left * ratio
        context.drawImage(imageEl, layoutLeft, layoutTop, layoutWidth, layoutHeight)
      }
    }
    // text
    for (let item of flyerText) {
      if (item.type === 'date') {
        for (let date of item.dates) {
          this.writeWrapText(context, date)
        }
      } else {
        this.writeWrapText(context, item)
      }
    }

    const imgFile = canvasEl.toDataURL('image/png')
    onChangeEventForm({
      checkedFlyer: imgFile
    })
  }

  writeWrapText = (context, item) => {
    let isExceedHeight = true

    const canvasWidth = this.backGroundImageElement.width
    const canvasHeight = this.backGroundImageElement.height
    const ratio = this.backGroundImageElement.width / THUMB_WIDTH

    let {
      text,
      size,
      align,
      right,
      left,
      top,
      width,
      height,
      font,
      widthAlign,
      nowrap,
      verticalAlign,
      rowGap = 0
    } = item
    let x = align === 'right' ? right * ratio : left * ratio
    let y = top * ratio
    let maxWidth = width ? width * ratio : canvasWidth
    let maxHeight = height ? height * ratio : canvasHeight
    let lineHeight = size * ratio + rowGap

    let lines = []
    let words = text ? (nowrap ? [text] : text.split(' ')) : []
    let line = ''

    while (isExceedHeight) {
      context.font = `${size * ratio || 16}px ${font}`

      for (var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + ' '
        var metrics = context.measureText(testLine)
        var testWidth = metrics.width
        if (testWidth > maxWidth && n > 0) {
          lines.push({
            text: line,
            x: this.writeTextAlign(context, x, line, align, maxWidth, widthAlign),
            y
          })
          line = words[n] + ' '
          y += lineHeight
        } else {
          line = testLine
        }
      }
      lines.push({
        text: line,
        x: this.writeTextAlign(context, x, line, align, maxWidth, widthAlign),
        y
      })
      // The first line does not need a gap
      if (lineHeight * lines.length - rowGap > maxHeight) {
        size -= 0.3
        line = ''
        lines = []
        lineHeight = size * ratio + rowGap
        y = top * ratio
      } else {
        let isExceedWidth = lines.some(i => context.measureText(i.text).width > maxWidth)
        if (!isExceedWidth) {
          isExceedHeight = false
          // test code
          if (verticalAlign) {
            lines = this.handleVerticalAlign({
              lines,
              maxHeight,
              lineHeight,
              rowGap,
              verticalAlign
            })
          }

          this.writeCanvasText({ context, lines, size: size * ratio, item })
        } else {
          size -= 0.3
          line = ''
          lines = []
          lineHeight = size * ratio + rowGap
          y = top * ratio
        }
      }
    }
  }

  handleVerticalAlign = params => {
    const { lines, maxHeight, lineHeight, rowGap, verticalAlign } = params

    const linesHeight = lineHeight * lines.length - rowGap
    const gapHeight = (maxHeight - linesHeight) / (verticalAlign === 'center' ? 2 : 1)

    const data = lines.map(item => ({
      text: item.text,
      x: item.x,
      y: item.y + gapHeight
    }))

    return data
  }

  writeCanvasText = params => {
    const { context, lines, size, item } = params

    context.beginPath()
    context.font = `${size || 16}px ${item.font}`
    context.fillStyle = item.color.replace('0x', '#')
    context.textBaseline = 'top'
    if (item.align === 'center') {
      context.textAlign = item.align
    } else {
      context.textAlign = 'left'
    }

    for (let line of lines) {
      const { text, x, y } = line
      context.fillText(text, x, y)
    }
    context.closePath()
  }

  writeTextAlign = (ctx, x, text, align, maxWidth, widthAlign) => {
    const canvasWidth = this.backGroundImageElement.width
    if (align === 'center') {
      return canvasWidth / 2
    } else if (align === 'right') {
      if (widthAlign === 'center') {
        return (
          canvasWidth -
          ctx.measureText(text).width -
          (maxWidth - ctx.measureText(text).width) / 2 -
          x
        )
      }
      return canvasWidth - ctx.measureText(text).width - x
    } else {
      if (widthAlign === 'center') {
        return (maxWidth - ctx.measureText(text).width) / 2 + x
      }
      return x
    }
  }

  handleClick = () => {
    const { onChangeEventForm, flyerDetail, eventForm, type } = this.props
    if (type === 'edit') {
      return
    }

    if (eventForm.flyer_design_number === flyerDetail.design_number) {
      onChangeEventForm({ flyer_design_number: null, flyer_design_slug: null, checkedFlyer: null })
      return
    }
    this.props.onFlyerSelected(this)

    onChangeEventForm({
      flyer_design_number: flyerDetail.design_number,
      flyer_design_slug: flyerDetail.design_slug
    })
  }

  renderLoading = () => {
    return (
      <div className={styles['container']}>
        <div className={styles['loading-container']} ref={this.detectImageInViewByRef}>
          <LoadingIndicator />
        </div>
      </div>
    )
  }

  renderFlyer = () => {
    const { eventForm, flyerDetail, type } = this.props
    this.design = new Design(this.props.flyerDetail, this.props.eventForm)
    this.handleText()

    return (
      <div className={styles['container']}>
        <div
          className={cn(styles['flyer-container'], {
          [styles['flyer-container-checked']]:
          type !== 'edit' && eventForm.flyer_design_number === flyerDetail.design_number
        })}
          onClick={this.handleClick}
      >
          {this.renderBackgroundImage()}
          {this.backGroundImageRef && this.renderOverlayImage()}
          {this.backGroundImageRef && this.flyerText.length > 0 && this.renderText()}
        </div>
      </div>
    )
  }

  renderFlyerPlaceholderFrame = () => {
    return (
      <div className={styles['container']}>
        <div>
          <img
            className={styles['image-inner']}
            src=""
            alt=""
          />
        </div>
      </div>
    )
  }

  initBackgroundImageElement = () => {
    this.backGroundImageElement.onload = () => {
      if (this.state.isLoading) {
        this.setState({ isLoading: false })
      }
    }

    this.backGroundImageElement.crossOrigin = 'Anonymous'
    this.backGroundImageElement.src = this.getDefaultBackgroundImage()
    this.backGroundImageElement.width = 640
    this.backGroundImageElement.height = 640 * (16 / 9)
    this.backGroundImageElement.className = styles['image-inner']
  }

  getDefaultBackgroundImage = () => {
    const { flyerDetail } = this.props
    return require(`src/assets/Layouts/Backgrounds/${flyerDetail.image_bg_slug}.jpg`)
  }

  render() {
    const { isLoading, isInView } = this.state
    if (isLoading) {
      this.initBackgroundImageElement()
      return this.renderLoading()
    } else if (isInView) {
      return this.renderFlyer()
    } else {
      return this.renderFlyerPlaceholderFrame()
    }
  }
}

FlyerContainerV2.propTypes = {
  flyerDetail: PropTypes.object,
  eventForm: PropTypes.object,
  onChangeEventForm: PropTypes.func,
  onFlyerSelected: PropTypes.func,
  onRef: PropTypes.func,
  type: PropTypes.string,
  customBgDataURL: PropTypes.string
}

function mapStateToProps(state) {
  return {
    eventForm: state.frontend.eventForm
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeEventForm: params => dispatch(changeEventForm(params))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FlyerContainerV2)



// WEBPACK FOOTER //
// ./src/containers/event/CreateEvent/FlyerContainerV2/FlyerContainerV2.jsx